import * as ReactDOM from "react-dom";
import * as React from "react";
import { salseData } from "./data.js";
import {
  AccumulationChartComponent,
  AccumulationSeriesCollectionDirective,
  AccumulationSeriesDirective,
  Inject,
  AccumulationLegend,
  PieSeries,
  AccumulationTooltip,
  AccumulationDataLabel,
} from "@syncfusion/ej2-react-charts";
import { Grid, Box, Typography, Stack } from "@mui/material";
import "./index.scss";
import LinearBar from "../LinearBar/index.js";
// import { setEnvironmentData } from "worker_threads";
// import { Kayaking } from "@mui/icons-material";
import { useParams } from "react-router";
import NoData from "../Nodata/index.js";
import { useTranslation } from "react-i18next";
export default function DougnutPieChart({ id, currency, tab, tip }) {
  const { t } = useTranslation("common");
  const params = useParams();
  const [data, setData] = React.useState([]);
  const color = ["#62FFE1", "#FB7300", "#CE3CCA", "#FCC11A"];
  // console.log(currency, "::CurrencyMain::");
  React.useEffect(() => {
    if (currency) {
      setData([]);
      const d = [];

      for (const key in currency) {
        const i = Object.keys(currency).indexOf(key);
        d.push({
          x: key,
          y: currency[i].percentage.toFixed(1),
          z: currency[i].amount.toFixed(2),
          a: currency[i].level,
          text: currency[i].currency,
          color: color[i],
        });
      }
      setData([...d]);
    }
  }, [currency]);
  // React.useEffect(() => {
  //   if (params) {
  //     setData([]);
  //   }
  // }, [params]);
  return (
    <div
      className="control-pane"
      style={{
        margin: "6px",
        // background: "#262626",
        background: "#090909",
        borderRadius: "5px",
        padding: "20px",
        position: "relative",
        minHeight: "200px",
        height: tab === "Tips" ? "232px" : "",
      }}
    >
      <Typography sx={{ color: "#FFFFFF80", fontSize: "17px" }}>
        {t("analytics.dougnut.text1")}
      </Typography>
      {data.length > 0 ? (
        <Grid container spacing={2}>
          <Grid
            item
            xs={6}
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "100%" }}>
              {data &&
                data?.map((d, index) => (
                  <Stack
                    direction="row"
                    gap="10px"
                    alignItems="center"
                    key={index}
                  >
                    <div className="skills-bar">
                      <div className="bar">
                        <Stack direction="row" justifyContent="space-between">
                          <Typography className="fs-14">{d.text}</Typography>
                          <Typography className="currency">
                            <span>:</span>
                            <span className="fs-14">{d.z}</span>
                          </Typography>
                        </Stack>
                        <LinearBar color={d.color} value={`${d.y}%`} />
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          marginTop={0.5}
                        >
                          <Typography className="fs-10">Level {d.a}</Typography>
                          <Typography className="fs-10">{d.y}%</Typography>
                        </Stack>
                      </div>
                    </div>
                  </Stack>
                ))}
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="overall_r">
              <AccumulationChartComponent
                height="200"
                // background="rgb(38, 38, 38)"
                background="#090909"
                ref={(pie) => (pie = pie)}
                legendSettings={{ visible: false }}
                enableSmartLabels={true}
                enableAnimation={false}
                tooltip={{
                  enable: true,
                  format: "${point.x} : <b>${point.y}%</b>",
                }}
              >
                <Inject
                  services={[
                    AccumulationLegend,
                    PieSeries,
                    AccumulationTooltip,
                    AccumulationDataLabel,
                  ]}
                />
                <AccumulationSeriesCollectionDirective>
                  <AccumulationSeriesDirective
                    palettes={[
                      "#FF5600",
                      "#62FFE1",
                      "#FF6A7B",
                      "#FFEE20",
                      "#FF1CBE",
                    ]}
                    dataSource={data}
                    pointColorMapping="color"
                    name={id}
                    xName="x"
                    yName="y"
                    explode={true}
                    explodeOffset="0%"
                    innerRadius="60%"
                    explodeIndex={0}
                    dataLabel={{
                      // visible: true,
                      position: "Inside",
                      // name: "text",
                      font: {
                        fontWeight: "600",
                        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                      },
                    }}
                    radius="100%"
                    background-color="black"
                  ></AccumulationSeriesDirective>
                </AccumulationSeriesCollectionDirective>
              </AccumulationChartComponent>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span
                  style={{
                    color: "#FFE437",
                    marginRight: "3px",
                    fontSize: "10px",
                  }}
                >
                  {/* 2 */}
                </span>
                <div className="progress-line last" style={{ width: "214px" }}>
                  <span></span>
                </div>
              </div>
              {/* <Stack className="overall_a">
                <Typography className="fs-14" sx={{ color: "#FFFFFF80" }}>
                  Overall
                </Typography>
                <Typography
                  className="fw-b"
                  sx={{
                    fontSize: "17px",
                    color: "#FFFFFF",
                  }}
                >
                  $<span>{tip ? tip : 0}</span>
                </Typography>
              </Stack> */}
            </Box>
          </Grid>
        </Grid>
      ) : (
        <NoData lable={t("noDataToShow")} />
      )}
    </div>
  );
}
